module.exports = __webpack_public_path__ + "static/media/team-average-empty.431c00a8.jpg";